
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"32","height":"32","rx":"4","fill":"url(#paint0_linear_11432_243)"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.16866 15.0269C12.7321 13.0512 15.775 11.7487 17.2976 11.1194C21.6448 9.32254 22.5481 9.01042 23.1369 9.00011C23.2664 8.99784 23.5559 9.02973 23.7435 9.18096C23.9018 9.30866 23.9454 9.48116 23.9663 9.60223C23.9871 9.7233 24.0131 9.9991 23.9924 10.2146C23.7569 12.6743 22.7375 18.6433 22.2189 21.3983C21.9995 22.564 21.5674 22.9548 21.1492 22.9931C20.2401 23.0762 19.5498 22.3961 18.6694 21.8225C17.2916 20.9251 16.5133 20.3664 15.176 19.4907C13.6305 18.4786 14.6323 17.9223 15.5131 17.0132C15.7436 16.7753 19.7489 13.1551 19.8264 12.8267C19.8361 12.7856 19.8451 12.6325 19.7536 12.5517C19.6621 12.4708 19.527 12.4985 19.4295 12.5204C19.2913 12.5516 17.0904 13.9972 12.8266 16.8573C12.2019 17.2836 11.636 17.4913 11.129 17.4804C10.5701 17.4684 9.49499 17.1664 8.69573 16.9082C7.71541 16.5915 6.93627 16.4241 7.00412 15.8863C7.03946 15.6062 7.42764 15.3197 8.16866 15.0269Z","fill":"white"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_11432_243","x1":"16","y1":"0","x2":"16","y2":"31.7627","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#2AABEE"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#229ED9"}})])])])
          )
        }
      }
    